import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
}

export const Logo = ({ className = '' }: LogoProps) => {
  return (
    <Link to="/" className={`flex items-center gap-2 ${className}`}>
      <div className="text-2xl font-bold tracking-tight">
        <span className="text-brand-primary">ARK</span>
        <span className="text-gray-900">ODD</span>
      </div>
    </Link>
  );
};
